import {
  DroppsProduct,
  ScentDetails,
  droppsProduct,
  PdpIngredientSection,
  PdpTabData,
  Badge,
} from "@/store";
import { LiquidProduct, liquidToShopifyProduct } from "../liquid";
import { getNumber } from "./validation";

export function getProduct({
  product,
  scents: scentsRaw,
  bundledProducts,
  badge,
  frontBoxImage,
  hiddenVariants,
  hidden,
  hideSubscription,
  overrideSpotPrice,
  overrideFutureShipments,
  originalOrder,
  pdpIngredientSection,
  pdpTabData,
  variantMetadata,
  productShortText,
  collections,
}: {
  product: LiquidProduct;
  scents: ScentDetails[];
  bundledProducts?: LiquidProduct[];
  badge?: Badge;
  frontBoxImage?: string;
  hiddenVariants: Set<number>;
  hidden?: boolean;
  hideSubscription?: boolean;
  overrideSpotPrice?: number;
  overrideFutureShipments?: string;
  originalOrder?: string[];
  pdpIngredientSection?: PdpIngredientSection | undefined;
  pdpTabData?: PdpTabData;
  variantMetadata?: any;
  productShortText?: string;
  collections?: Array<{
    id: string;
    handle: string;
    title: string;
  }>;
}): [DroppsProduct, ScentDetails[]] {
  const scents = (scentsRaw || []).map((scent) => ({
    ...scent,
    title: `${scent.title} – Dropps`,
  }));

  if (overrideSpotPrice) {
    product.price = overrideSpotPrice;
    product.variants = product.variants.map((v) => {
      v.price = overrideSpotPrice;
      return v;
    });
  }
  const liquidBundle: LiquidProduct[] | undefined =
    bundledProducts && bundledProducts.length > 0 ? [] : undefined;
  (originalOrder || []).forEach((id) => {
    const index = bundledProducts!.findIndex(
      (bundle) =>
        bundle.id === getNumber(id.replace("gid://shopify/Product/", ""))
    );
    if (index !== undefined && index > -1 && bundledProducts && liquidBundle) {
      liquidBundle.push(bundledProducts[index]);
    }
  });
  const intermediate = liquidToShopifyProduct(product, {
    bundledItems: liquidBundle,
    hidden,
    hiddenVariants,
    badge,
    collections,
    frontBoxImage,
    hideSubscription,
    overrideFutureShipments,
    pdpIngredientSection,
    pdpTabData,
    variantMetadata,
    productShortText: productShortText ?? "",
  });
  return [droppsProduct(intermediate), scents];
}

/// When passing props to rendering component, remove the discriminant so the
/// rendering components don't accidentally interpret the discriminant.
export function trimPortalProps<T extends { kind?: string; id?: string }>(
  input: T
) {
  const { kind, id, ...rest } = input;
  return rest;
}
